module.exports = __webpack_public_path__ + "img/soln-meta-final.ed699e07.jpg";